import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getLensStock } from "service/api";
// import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";



function DatatableTables({ refresh }) {
  const [lensStock, setLensStock] = useState([]);

  useEffect(() => {
    fetchLensStock();
  }, [refresh]);

  const fetchLensStock = async () => {
    try {
      const response = await getLensStock();
      if (Array.isArray(response?.data?.data)) {
        setLensStock(response.data.data);
      } else {
        toast.error("Invalid lens stock data format");
        console.log("Invalid lens stock data:", response);
        setLensStock([]);
      }
    } catch (error) {
      toast.error("Error fetching lens stock");
      console.error("Fetch error:", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Lens Code",
        accessor: "lcode",
      },
      {
        Header: "Quantity",
        accessor: "lqty",
      },
      {
        Header: "Add date",
        accessor: "add_date",
      },
      {
        Header: "Add time",
        accessor: "add_time",
      },
    ],
    []
  );
  //meta title
  document.title = "Lens | List";

  return (
    //<div className="page-content">
    <div className="container-fluid mt-3">
      {/* <div className="d-flex justify-content-between align-items-center mb-4">
             <h1 className="page-title"></h1>
             <Link to="/add_frames" className="btn btn-primary">ADD NEW FRAMES</Link>
            </div>
                <Breadcrumbs title="Setting" breadcrumbItem="Frames" /> */}
      <TableContainer
        columns={columns}
        data={lensStock}
        isGlobalFilter={true}
        isAddOptions={false}
        customPageSize={10}
        className="custom-header-css"
      />
      {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
      {/* <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal} centered>
          <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this region?
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={confirmDelete}>Yes, Delete</Button>
            <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
          </ModalFooter>
        </Modal> */}
    </div>
    //  </div>
  );
}

export default DatatableTables;